import { useState, useEffect } from 'react'

export type OfferState = 'LAUNCH' | 'SECOND_CHANCE' | 'EXPIRED'

export function useCountdown() {
  const [offerState, setOfferState] = useState<OfferState>('LAUNCH')
  const [timeLeft, setTimeLeft] = useState({
    hours: 24,
    minutes: 0,
    seconds: 0,
  })
  const [isExpired, setIsExpired] = useState(false)

  useEffect(() => {
    const now = new Date().getTime()
    let firstVisit = localStorage.getItem('firstVisitTime')
    let secondOfferStart = localStorage.getItem('secondOfferStartTime')

    if (!firstVisit) {
      firstVisit = now.toString()
      localStorage.setItem('firstVisitTime', firstVisit)
    }

    const updateTimer = () => {
      const currentTime = new Date().getTime()
      const elapsedSinceFirstVisit = currentTime - parseInt(firstVisit!)
      const launchDuration = 24 * 60 * 60 * 1000 // 24 hours

      if (elapsedSinceFirstVisit < launchDuration) {
        // LAUNCH STATE
        setOfferState('LAUNCH')
        const remaining = launchDuration - elapsedSinceFirstVisit
        setTimeLeft({
          hours: Math.floor(
            (remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
          ),
          minutes: Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((remaining % (1000 * 60)) / 1000),
        })
      } else {
        // 24h expired
        if (!secondOfferStart) {
          secondOfferStart = currentTime.toString()
          localStorage.setItem('secondOfferStartTime', secondOfferStart)
        }

        const elapsedSinceSecondOffer = currentTime - parseInt(secondOfferStart)
        const secondOfferDuration = 5 * 60 * 1000 // 5 minutes

        if (elapsedSinceSecondOffer < secondOfferDuration) {
          // SECOND CHANCE STATE
          setOfferState('SECOND_CHANCE')
          const remaining = secondOfferDuration - elapsedSinceSecondOffer
          setTimeLeft({
            hours: 0,
            minutes: Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60)),
            seconds: Math.floor((remaining % (1000 * 60)) / 1000),
          })
        } else {
          // EXPIRED STATE
          setOfferState('EXPIRED')
          setIsExpired(true)
          setTimeLeft({ hours: 0, minutes: 0, seconds: 0 })
        }
      }
    }

    updateTimer()
    const interval = setInterval(updateTimer, 1000)
    return () => clearInterval(interval)
  }, [])

  const formatTime = (value: number) => value.toString().padStart(2, '0')
  const formattedTime = `${formatTime(timeLeft.hours)}:${formatTime(timeLeft.minutes)}:${formatTime(timeLeft.seconds)}`

  const currentPrice =
    offerState === 'LAUNCH'
      ? 6.39
      : offerState === 'SECOND_CHANCE'
        ? 9.99
        : 29.0
  const checkoutLink =
    offerState === 'LAUNCH'
      ? 'https://pay.hotmart.com/X104778374A?off=fphumdnx&checkoutMode=10'
      : 'https://pay.hotmart.com/X104778374A?off=pes4slnc&checkoutMode=10'

  return {
    offerState,
    timeLeft,
    isExpired,
    formattedTime,
    currentPrice,
    checkoutLink,
  }
}
